import React, { useEffect, useState } from "react";
import MandatorySign from "../../Components/MandatorySign";
import Spinner from "../../Components/Spinner";
import SingleLoaderItem from "../../Loaders/SingleLoaderItem";
import AgentLoader from "../../Loaders/AgentLoader";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenOrgSettings = ({
    account_id,
    org_id,
    singleOrgData,
    loadingSingleOrg,
    fetchSingleOrganization
}) => {
    const {t} = useLanguage()
    const [isDifferent, setIsDifferent] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [formData, setFormData] = useState({
        name: "",
        description: ""
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!formData.name.trim()) {
            setErrorMessage({ message: t.organizations.org_name_required, display: true });
            return;
        }

        if (!formData.description.trim()) {
            setErrorMessage({ message: t.organizations.org_desc_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/create_organization`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    name: formData.name,
                    description: formData.description
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                fetchSingleOrganization(org_id)
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    useEffect(() => {
        if (!singleOrgData) return;

        const isChanged =
            formData.name !== (singleOrgData.name || "") ||
            formData.description !== (singleOrgData.description || "");

        setIsDifferent(isChanged);
    }, [formData, singleOrgData]);

    useEffect(() => {
        if (!loadingSingleOrg) {
            setFormData({
                name: singleOrgData.name || "",
                description: singleOrgData.description || ""
            })
        }
    }, [loadingSingleOrg])


    // useEffect(() => {
    //     fetchSingleOrganization(org_id)
    // }, [org_id])


    return (
        <div className="analytics_cont_body_inner">
            {loadingSingleOrg ? (
                <div className="open_item_form">
                <AgentLoader  length={1}/>
                </div>
            ) : (
                <div className="open_item_cont">
                    <div className="open_item_form">
                        <div className="label_input">
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                            <input
                                type="text"
                                name="name"
                                maxLength={100}
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="EX - Accounting department"
                                className="register_form_first fade-in"
                                autoComplete="off"
                            />
                        </div>
                        <div className="label_input">
                            <label className="input_label">
                            {t.description} <MandatorySign message={t.mandatory_field} />
                            </label>
                            <textarea
                                name="description"
                                maxLength={300}
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="EX - Accounting department of mybusiness.com"
                                className="register_form_first textarea_reg fade-in"
                                autoComplete="off"
                            />
                        </div>
                        {isDifferent && (
                            <button className="open_item_form_btn fade-in" onClick={handleSave}>
                                {loadingSave ? (
                                    <Spinner loading={true} />
                                ) : (
                                    t.save
                                )}
                            </button>
                        )}
                        <ErrorMessage err={errorMessage}/>
                    </div>
                </div>
            )}

        </div>
    )
}

export default OpenOrgSettings